import { render, staticRenderFns } from "./selfrun.vue?vue&type=template&id=07db79e4&scoped=true&"
import script from "./selfrun.vue?vue&type=script&lang=js&"
export * from "./selfrun.vue?vue&type=script&lang=js&"
import style0 from "./selfrun.vue?vue&type=style&index=0&id=07db79e4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07db79e4",
  null
  
)

export default component.exports